import { useEffect, useState } from "react"
import TextField from "../components/forms/TextField"
import NumberField from "../components/forms/NumberField"
import TextAreaField from "../components/forms/TextAreaField"
import ImagePickerField from "../components/forms/ImagePickerField"
import { useNavigate, useParams } from "react-router-dom"

import { editProduct, getSingleProduct } from '../redux/products/ProductSlice'
import { useDispatch, useSelector } from "react-redux"
import reactCSS from 'reactcss'
import { SketchPicker } from 'react-color'

export default function ProductEdit() {
    const [submitted, setSubmitted] = useState(false)
    const [submittedCount, setSubmittedCount] = useState(0)
    const [product, setProduct] = useState({})
    const params = useParams()
    const [tags, setTags] = useState(['sample'])
    const [inputTag, setInputTag] = useState('')
    const [productForm, setProductForm] = useState(null)
    const navigate = useNavigate()
    const [pictures, setPictures] = useState([{ path: "", extension: "", url: "" }])
    const [pickedColor, setPickedColor] = useState('')
    const [showPallete, setShowPallete] = useState(false)
    const [color, setColor] = useState({
        r: '241',
        g: '112',
        b: '19',
        a: '1',
    })
    const productRedux = useSelector(state => state.Product)

    const dispatch = useDispatch()

    const styles = reactCSS({
        'default': {
            color: {
                width: '36px',
                height: '14px',
                borderRadius: '2px',
                background: `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`,
            },
            swatch: {
                padding: '5px',
                background: '#fff',
                borderRadius: '1px',
                boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                display: 'inline-block',
                cursor: 'pointer',
            },
            popover: {
                position: 'absolute',
                zIndex: '2',
            },
            cover: {
                position: 'fixed',
                top: '0px',
                right: '0px',
                bottom: '0px',
                left: '0px',
            },
        },
    })

    useEffect(() => {
        if (submitted && !productRedux.isButtonLoading) {
            navigate(-1)
        }
    }, [productRedux.isButtonLoading])

    useEffect(() => {
        const productInfo = productRedux.products.filter(product => product.id === params.id).pop()

        if (productInfo?.id) {
            setProduct(productInfo)
            setPictures(productInfo.pictures)
            if (productInfo?.tags?.length !== 0) {
                setTags(productInfo.tags || [])
                console.info('product info is 1', tags)
            } else {
                setTags([])
            }
        } else {
            dispatch(getSingleProduct({ productId: params.id }))
        }
    }, [productRedux.products])

    const populatePicture = (index, pictureData) => {
        setPictures(prevState => prevState.map((statePicture, stateIndex) => stateIndex === index ? pictureData.fieldValue : statePicture))
    }

    const pickTagColor = (color) => {
        setPickedColor(color)
    }

    const removeTag = (index) => {
        setTags(prev => prev.filter((tag, i) => index == i ? null : tag))
    }

    const addTag = () => {
        const tag = inputTag.fieldValue
        if (tag?.trim()?.length !== 0) {
            const tagObj = {
                name: tag,
                bg_color: color,
            }
            console.info('tags are ', tags)
            setTags(prev => [tagObj, ...prev])
        }
    }

    const submitProductForm = (ev) => {
        ev.preventDefault()
        setSubmitted(true)

        setSubmittedCount(submittedCount + 1)

        let hasError = false
        for (const key in productForm) {
            if (productForm[key].isRequired && !productForm[key].fieldValue || productForm[key].error) {
                hasError = true
                break
            } else {
                hasError = false
            }
        }

        if (!hasError) {
            const title = productForm.title.fieldValue
            const description = productForm.description.fieldValue
            const price = productForm.price.fieldValue


            dispatch(editProduct({
                id: params.id,
                title: title,
                description: description,
                price: price,
                pictures: pictures,
                tags: tags,
                existingPictures: product.pictures,
                created_date: product.created_date
            }))
        }
    }

    const addPicture = () => {
        if (pictures.length < 4) {
            setPictures([...pictures, { path: "", extension: '', url: "" }])
        }
    }

    const palleteOnChange = (color) => {
        setColor(color.rgb)
    }



    return productRedux.isSingleLoading ? <div className="flex items-center justify-center"><div role="status">
        <svg aria-hidden="true" className="mr-2 w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
        </svg>
        <span className="sr-only">Loading...</span>
    </div> Loading </div> : <>
        <div className='flex mb-20'>
            <button
                onClick={() => navigate(-1)}
                className="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 9l-3 3m0 0l3 3m-3-3h7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>

                <span className='ml-2'>Back</span>
            </button>
        </div>
        <form onSubmit={submitProductForm}>

            {
                pictures.map((picture, index) => <ImagePickerField
                    fieldName="picture"
                    label={`Product Picture ${index + 1}`}
                    isSubmitted={submitted}
                    defaultValue={picture}
                    onChange={e => populatePicture(index, e)}
                />)
            }
            {
                pictures.length < 4 ? <button type="button" onClick={() => addPicture()} className="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
                    </svg>


                    <span className='ml-2'>Add Picture</span>
                </button> : null
            }

            <TextField
                fieldName="title"
                label="Product Title"
                isSubmitted={submitted}
                defaultValue={product.title}
                isRequired
                onChange={e => setProductForm(productForm => ({ ...productForm, title: e }))}
            />

            <div>
                <div className="flex flex-row items-center">
                    <div className="w-full">
                        <TextField
                            fieldName="title"
                            defaultValue={inputTag.fieldValue}
                            label="Product Tag"
                            isRequired
                            onChange={e => setInputTag(e)}
                        />
                    </div>

                    <button
                        onClick={() => addTag()}
                        type="button"
                        className="inline-flex items-center mb-3 h-11 w-11 justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto">
                        <span className=''>Add</span>
                    </button>
                </div>

                <div className="flex flex-wrap">
                    <div>
                        <div style={styles.swatch} onClick={() => setShowPallete(true)}>
                            <div style={styles.color} />
                        </div>
                        {showPallete ? <div style={styles.popover}>
                            <div style={styles.cover} onClick={() => setShowPallete(false)} />
                            <SketchPicker color={color} onChange={palleteOnChange} />
                        </div> : null}

                    </div>
                </div>

                <div className="flex py-5">
                    {
                        tags && tags?.map((tag, index) => <div
                            onClick={() => removeTag(index)}
                            style={{ background: `rgba(${tag?.bg_color?.r}, ${tag?.bg_color?.g}, ${tag?.bg_color?.b}, ${tag?.bg_color?.a})`}}
                            className="text-white mr-4 text-xs inline-flex items-center font-bold leading-sm uppercase px-3 py-1 rounded-full cursor-pointer"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            {tag.name}
                        </div>)
                    }
                </div>
            </div>


            <TextAreaField
                fieldName="description"
                label="Product Description"
                isSubmitted={submitted}
                defaultValue={product.description}
                onChange={e => setProductForm(productForm => ({ ...productForm, description: e }))}
            />

            <NumberField
                fieldName="price"
                label="Product Price"
                isSubmitted={submitted}
                defaultValue={product.price}
                isRequired
                onChange={e => setProductForm(productForm => ({ ...productForm, price: e }))}
            />

            <button
                type="submit"
                disabled={productRedux.isButtonLoading}
                className="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto">
                {
                    productRedux.isButtonLoading ? <span className='ml-2'>Saving Changes...</span> : <> <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                    </svg>
                        <span className='ml-2'>Save Changes</span></>
                }

            </button>
        </form> </>

}
